module.exports = __webpack_public_path__ + "img/confort.55759e1c.png";